import SEO from "@/components/SEO";
import { FadeUp } from "@/components/Reveal";
import RootMap from "@/components/RootMap";
import CtaBand from "@/sections/CtaBand";

const PorOndeComecar = () => (
  <>
    <SEO
      title="Por onde começar? — Psicoterapia ou Avaliação Neuropsicológica | Sabrina Mota"
      description="Entenda as possibilidades e conheça qual serviço pode estar relacionado ao que você procura: psicoterapia, avaliação neuropsicológica ou uma conversa inicial."
      path="/por-onde-comecar"
    />
    <section className="pt-28 lg:pt-40" data-testid="por-onde-comecar-page">
      <div className="container-x pb-20 lg:pb-28">
        <FadeUp>
          <p className="eyebrow" data-testid="por-onde-comecar-eyebrow">Orientação</p>
        </FadeUp>
        <FadeUp delay={0.08}>
          <h1 className="mt-5 max-w-3xl font-serif text-4xl font-light leading-[1.08] tracking-tight text-ink sm:text-5xl lg:text-6xl" data-testid="por-onde-comecar-title">
            Por onde <em className="italic text-raiz-700">começar?</em>
          </h1>
        </FadeUp>
        <FadeUp delay={0.16}>
          <p className="lead mt-7 max-w-2xl">
            Entenda as possibilidades e conheça qual serviço pode estar relacionado ao que você procura.
          </p>
        </FadeUp>
        <div className="mt-16">
          <RootMap />
        </div>
      </div>
    </section>
    <CtaBand title="Prefere conversar diretamente?" text="Explique brevemente sua demanda no primeiro contato e receba informações sobre os serviços disponíveis." />
  </>
);

export default PorOndeComecar;
